'use strict';

var cov_tsafpvjsj = function () {
  var path = 'C:\\Users\\Bruno\\Documents\\Projects\\SAWAP\\src\\routes.js',
      hash = 'e6fe07bd6ac8c00b607fa0aead90854033930b68',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'C:\\Users\\Bruno\\Documents\\Projects\\SAWAP\\src\\routes.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 0
        },
        end: {
          line: 8,
          column: 5
        }
      },
      '1': {
        start: {
          line: 4,
          column: 4
        },
        end: {
          line: 4,
          column: 31
        }
      },
      '2': {
        start: {
          line: 5,
          column: 4
        },
        end: {
          line: 7,
          column: 6
        }
      },
      '3': {
        start: {
          line: 6,
          column: 6
        },
        end: {
          line: 6,
          column: 39
        }
      },
      '4': {
        start: {
          line: 12,
          column: 2
        },
        end: {
          line: 12,
          column: 52
        }
      },
      '5': {
        start: {
          line: 13,
          column: 2
        },
        end: {
          line: 13,
          column: 48
        }
      },
      '6': {
        start: {
          line: 14,
          column: 2
        },
        end: {
          line: 17,
          column: 5
        }
      },
      '7': {
        start: {
          line: 18,
          column: 2
        },
        end: {
          line: 240,
          column: 7
        }
      },
      '8': {
        start: {
          line: 59,
          column: 10
        },
        end: {
          line: 64,
          column: 14
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 3,
            column: 28
          },
          end: {
            line: 3,
            column: 29
          }
        },
        loc: {
          start: {
            line: 3,
            column: 52
          },
          end: {
            line: 8,
            column: 3
          }
        },
        line: 3
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 5,
            column: 35
          },
          end: {
            line: 5,
            column: 36
          }
        },
        loc: {
          start: {
            line: 5,
            column: 47
          },
          end: {
            line: 7,
            column: 5
          }
        },
        line: 5
      },
      '2': {
        name: 'routesConfig',
        decl: {
          start: {
            line: 11,
            column: 9
          },
          end: {
            line: 11,
            column: 21
          }
        },
        loc: {
          start: {
            line: 11,
            column: 98
          },
          end: {
            line: 241,
            column: 1
          }
        },
        line: 11
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 62,
            column: 12
          },
          end: {
            line: 62,
            column: 134
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 62,
            column: 45
          },
          end: {
            line: 62,
            column: 47
          }
        }, {
          start: {
            line: 62,
            column: 50
          },
          end: {
            line: 62,
            column: 134
          }
        }],
        line: 62
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0
    },
    b: {
      '0': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

cov_tsafpvjsj.s[0]++;
angular.module('app').config(routesConfig).run(function ($rootScope, $state) {
  cov_tsafpvjsj.f[0]++;
  cov_tsafpvjsj.s[1]++;

  $rootScope.$state = $state;
  cov_tsafpvjsj.s[2]++;
  $rootScope.getCurrentProject = function () {
    cov_tsafpvjsj.f[1]++;
    cov_tsafpvjsj.s[3]++;

    return $rootScope.currentProject;
  };
});

/** @ngInject */
function routesConfig($stateProvider, $urlRouterProvider, $locationProvider, $ocLazyLoadProvider) {
  cov_tsafpvjsj.f[2]++;
  cov_tsafpvjsj.s[4]++;

  $locationProvider.html5Mode(true).hashPrefix('!');
  cov_tsafpvjsj.s[5]++;
  $urlRouterProvider.otherwise('/app/projects');
  cov_tsafpvjsj.s[6]++;
  $ocLazyLoadProvider.config({
    // Set to true if you want to see what and when is dynamically loaded
    debug: false
  });
  cov_tsafpvjsj.s[7]++;
  $stateProvider.state('login', {
    url: '/login',
    templateUrl: 'app/login/login.html',
    data: { index: 1 }
  }).state('loading', {
    url: '/loading',
    templateUrl: 'app/loading/template.html'
  }).state('index', {
    abstract: true,
    url: '/app',
    templateUrl: 'app/common/content.html'

  }).state('index.mail', {
    url: '/mail',
    templateUrl: 'app/mail/view.html',
    data: { indexTrad: 'MESSAGE.EMAIL_BOX' }
  }).state('index.dashboard', {
    url: '/dashboard',
    templateUrl: 'app/dashboard/view.html',
    data: { indexTrad: 'DASHBOARD.DASHBOARD' },
    icon: 'fa-dashboard'
  }).state('index.profil', {
    url: '/profil',
    templateUrl: 'app/profil/view.html'
  }).state('index.alerts', {
    url: '/alerts',
    templateUrl: 'app/alert/view.html',
    data: { indexTrad: 'DASHBOARD.DASHBOARD' }
  }).state('index.projects', {
    url: '/projects',
    templateUrl: 'app/project/view.html',
    resolve: {
      loadPlugin: function loadPlugin($ocLazyLoad, $rootScope) {
        cov_tsafpvjsj.s[8]++;

        return $ocLazyLoad.load([{
          serie: true,
          files: ['http://cdnjs.cloudflare.com/ajax/libs/summernote/0.8.8/summernote-lite.css', 'https://cdnjs.cloudflare.com/ajax/libs/summernote/0.8.8/summernote-bs4.min.js'].concat($rootScope.language.id == 'en' ? (cov_tsafpvjsj.b[0][0]++, []) : (cov_tsafpvjsj.b[0][1]++, ['https://cdnjs.cloudflare.com/ajax/libs/summernote/0.8.8/lang/summernote-fr-FR.js']))
        }]);
      }
    }
  }).state('index.Unit', {
    url: '/EditView',
    templateUrl: 'app/Units/EditView.html',
    icon: 'fa-tag',
    data: { indexTrad: 'MENU.UN' }
  }).state('index.Sfin', {
    url: '/SourceFinView',
    templateUrl: 'app/SourceFin/SourceFinView.html',
    data: { pageTitle: 'SourceFin view' }
  }).state('index.Actors', {
    url: '/ActorsView',
    templateUrl: 'app/Actors/ActorsView.html',
    data: { indexTrad: 'MENU.AC' },
    icon: 'fa-user-circle'
  }).state('index.TBordActor', {
    url: '/TBordActor',
    templateUrl: 'app/Actors/TBordActors.html',
    data: { pageTitle: ' dashboard Actors view' }
  }).state('index.step_one', {
    url: '/step_one',
    templateUrl: 'app/wizard/step_one.html',
    data: { pageTitle: 'Actors' }
  }).state('index.step_two', {
    url: '/step_two',
    templateUrl: 'app/wizard/step_two.html',
    data: { pageTitle: 'Actors' }
  }).state('index.periods', {
    url: '/periods',
    templateUrl: 'app/time_division/view.html',
    data: { indexTrad: 'MENU.D_P' }
  }).state('index.activity_breakdown', {
    url: '/activity_breakdown',
    templateUrl: 'app/time_division/view_1.html',
    data: { indexTrad: 'MENU.D_PL' }
  }).state('index.geographic_map', {
    url: '/geographic_map',
    templateUrl: 'app/geographic_map/view.html',
    data: { indexTrad: 'MENU.P_G' },
    icon: 'fa-globe'
  }).state('index.logical_plan', {
    url: '/logical_plan',
    templateUrl: 'app/logical_plan/view.html',
    data: { indexTrad: 'MENU.P_L' },
    icon: 'fa-sitemap'
  }).state('index.flag', {
    url: '/flag',
    templateUrl: 'app/flag/view.html',
    data: { indexTrad: 'MENU.FL' },
    icon: 'fa-flag'
  }).state('index.procurement', {
    url: '/procurement',
    templateUrl: 'app/procurement_plan/view.html',
    data: { indexTrad: 'MENU.P_M' }
  }).state('indicator', {
    abstract: true,
    url: '/indicator',
    templateUrl: 'app/common/content.html'
  }).state('indicator.TypeIndic', {
    url: '/TypeIndicView',
    icon: 'fa-list',
    data: { indexTrad: 'MENU.T_I' },
    templateUrl: 'app/TypeIndic/TypeIndicView.html'

  }).state('indicator.indicator', {
    icon: 'fa-sliders',
    url: '/indicators',
    templateUrl: 'app/indicator/view.html',
    data: { indexTrad: 'MENU.IN' }

  }).state('indicator.resultframe', {
    url: '/resultframe',
    data: { indexTrad: 'MENU.R_F' },
    templateUrl: 'app/results_frame/view.html',
    icon: 'fa-sitemap'
  }).state('activity', {
    abstract: true,
    url: '/activity',
    templateUrl: 'app/common/content.html'
  }).state('activity.planning', {
    url: '/planning',
    templateUrl: 'app/activities/view.html'
  }).state('activity.ptba', {
    url: '/ptba',
    templateUrl: 'app/ptba/view.html'

  }).state('activity.ptbaannuel', {
    url: '/ptbaannuel',
    templateUrl: 'app/ptbaannuel/view.html'
  }).state('activity.ganttchart', {
    url: '/ganttChart',
    templateUrl: 'app/ganttChart/view.html'

  }).state('activity.contract_follow', {
    url: '/contract_follow',
    data: { indexTrad: 'MENU.S_M' },
    templateUrl: 'app/contract/contractView.html'
  }).state('activity.contract_ppm', {
    url: '/contract_ppm',
    data: { indexTrad: 'MENU.S_PPM' },
    templateUrl: 'app/contract_ppm/view.html'
  })
  // Base documentaire
  .state('document', {
    abstract: true,
    url: '/document',
    templateUrl: 'app/common/content.html'
  }).state('document.reportType', {
    url: '/report_type',
    templateUrl: 'app/report_type/view.html',
    data: { indexTrad: 'MENU.T_RA' },
    icon: 'fa-list'
  }).state('document.reportCalendar', {
    url: '/report_calendar',
    icon: 'fa-clock-o',
    data: { indexTrad: 'MENU.CA_R' },
    templateUrl: 'app/report_calendar/view.html'
  }).state('document.document', {
    url: '/document_file',
    icon: 'fa-file',
    templateUrl: 'app/document/view.html',
    data: { indexTrad: 'MENU.C_D' }
  }).state('document.photolibrary', {
    icon: 'fa-file-image-o',
    url: '/photo_library',
    templateUrl: 'app/photolibrary/view.html',
    data: { indexTrad: 'MENU.PH' }
  }).state('users', {
    abstract: true,
    url: '/user',
    templateUrl: 'app/common/content.html'
  }).state('users.mangement', {
    url: '/management',
    icon: 'fa-user',
    templateUrl: 'app/user/view.html'
  }).state('users.group', {
    url: '/group',
    icon: 'fa-users',
    templateUrl: 'app/user/usergroup/view.html'
  }).state('users.privileges', {
    url: '/privileges',
    icon: 'fa-tags',
    templateUrl: 'app/user/privileges/view.html'
  });
}